import React from 'react';
import Loading from 'ui/elements/Loading';
import Overlay from 'ui/views/dialogs/Overlay/Overlay';

interface Props {
  text?: string;
  visible?: boolean;
}

export default function BlockUi(props: Props) {
  return props.visible ? (
    <Overlay
      style={{
        cursor: 'wait',
      }}
      isActive={props.visible}
      position="center"
    >
      <div>
        <Loading />
        {props.text && (
          <div className="text-body u-content-spacing-top" style={{ fontSize: '2rem' }}>
            {props.text}
          </div>
        )}
      </div>
    </Overlay>
  ) : null;
}
